
import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class TimePicker extends Vue {
  @Prop() isSingleTime = false;
  @Prop() timeStart = "";
  @Prop() timeEnd = "";

  @Emit() timeChange() {
    return this.isSingleTime
      ? this.timeStart
      : `${this.timeStart}-${this.timeEnd}`;
  }

  timeStartMenu = false;
  timeEndMenu = false;
}
